import { useMemo } from "react";
import { getOccurrenceStepLabelByStepValue } from "../enums/occurrenceStep";

export interface OccurrenceStep {
  step?: string;
  name?: string;
  dtStart?: Date | null | undefined;
  dtEnd?: Date | null | undefined;
  estimatedTime?: string | null;
  logs?: {
    startDate?: Date | null | undefined;
    endDate?: Date | null | undefined;
  }[];
}

interface CurrentStepResult {
  label: string;
  isInProgress: boolean;
}

/**
 * Hook para calcular a etapa atual de uma ocorrência.
 */
export function useCurrentStep(steps: OccurrenceStep[] = []): CurrentStepResult | null {
  return useMemo(() => {
    if (!steps.length) return null;

    const inProgress = steps.find(s => s.dtStart && !s.dtEnd);

    if (inProgress) {
      return {
        label: getOccurrenceStepLabelByStepValue(inProgress.step || "") || inProgress.name || "Etapa atual",
        isInProgress: true,
      };
    }

    return null;
  }, [steps]);
}
